import { AxiosError } from "axios";

import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { SecurityQuestions } from "@/types/policy-document-types";

export const useSubmitPolicyDocData = (policyId: string | null | undefined) => {
  const submitPolicyDocData = async (
    securityQuestions: SecurityQuestions | null
  ) => {
    if (!policyId) {
      throw new Error("Policy ID is required");
    }

    try {
      const requestBody = {
        type: "Policy",
        channel: "ONLINE",
        attributes: {
          domain: PRODUCT_DOMAIN,
          securityQuestionRequest: { answers: securityQuestions },
        },
      };

      const config = {
        data: requestBody,
      };
      const response = await axioInstance.post(
        `policy/${policyId}/requestDocumentLinks`,
        config
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      return axiosError.response?.status;
    }
  };
  return submitPolicyDocData;
};
